import React from 'react';
import { RadioButton } from 'primereact/radiobutton';
import classNames from 'classnames';
import './RadioButtonGroup.scss';
import { FormFieldError } from '../../hooks/useForm';
import { FormElementError } from '../FormElementError/FormElementError';

interface RadioOption<T> {
  value: T;
  label: string;
  id: string;
  disabled?: boolean;
}

interface Props<T> {
  options: RadioOption<T>[];
  value: T | undefined;
  onChange: (value: T) => void;
  name: string;
  error?: FormFieldError;
  className?: string;
  layout?: 'horizontal' | 'vertical';
}

export const RadioButtonGroup = <T extends string | number | boolean>({
  options,
  value,
  onChange,
  name,
  error,
  className,
  layout = 'horizontal',
}: Props<T>) => {
  return (
    <div
      className={classNames('radio-button-group', className, {
        'radio-button-group-vertical': layout === 'vertical',
      })}
    >
      <div className={classNames('radio-options', { 'p-invalid': error })}>
        {options.map((option) => (
          <div key={option.id} className={classNames('radio-option', { 'radio-option-disabled': option.disabled })}>
            <RadioButton
              inputId={option.id}
              name={name}
              value={option.value}
              onChange={(e) => onChange(e.value)}
              checked={value === option.value}
              className={classNames({ 'p-invalid': error })}
              disabled={option.disabled}
            />
            <label htmlFor={option.id}>{option.label}</label>
          </div>
        ))}
      </div>
      <FormElementError>{typeof error === 'string' ? error : null}</FormElementError>
    </div>
  );
};
